import React from 'react';
import * as S from './style';
import { FormStatusInfo, Label, SpaceDiv, Btn } from 'components';
import { ReactComponent as ImgDocChecked } from 'assets/img/status/img_doc_checked.svg';
interface Props {
  serviceType: string;
  createdDate: string;
  checkedDate: string;
  interviewExpectation?: Array<{
    type: number;
    title: string;
    content: string;
  }>;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function DocChecked({
  serviceType,
  createdDate,
  checkedDate,
  interviewExpectation,
  onClick,
}: Props): React.ReactElement {
  return serviceType === 'move_cleaning' ? (
    <FormStatusInfo
      subTitle={[
        '감사합니다! 서류가 확인되어',
        '인터뷰 대상자로 등록되었습니다.',
      ]}
      image={<ImgDocChecked />}
      inHomeBtn={true}
    >
      <S.CaptionWrapper>
        짐싸 파트너는 고객과 업체 간의 공급/수요에 맞춰 지역별 파트너를 모집하고
        있습니다.
        <br />
        하단의 인터뷰 예상 대기 일을 참고해주시면, 해당 기간 내에 인터뷰
        연락드릴 수 있도록 하겠습니다.
        <br />
      </S.CaptionWrapper>
      <S.DateWrapper>
        <Label
          contents={'가입 신청일'}
          color={'gray_opacity_600'}
          fontStyle={'body2'}
        />
        <Label
          contents={createdDate}
          color={'gray_opacity_800'}
          fontStyle={'body1'}
        />
      </S.DateWrapper>
      <S.DateWrapper>
        <Label
          contents={'서류 승인일'}
          color={'gray_opacity_600'}
          fontStyle={'body2'}
        />
        <Label
          contents={checkedDate}
          color={'gray_opacity_800'}
          fontStyle={'body1'}
        />
      </S.DateWrapper>
      <SpaceDiv height={36} />
      <S.GuideTitleWrapper>
        <Label
          contents={'인터뷰 예상 대기일'}
          color={'gray_opacity_800'}
          fontStyle={'title_bold'}
        />
      </S.GuideTitleWrapper>
      <S.GuideContainer>
        {interviewExpectation?.map((item, index) => (
          <S.GuideWrapper key={index}>
            <Label
              contents={item.title}
              color={'gray_opacity_800'}
              fontStyle={'body2'}
            />
            <SpaceDiv height={4} />
            <Label
              contents={item.content}
              color={'gray_opacity_600'}
              fontStyle={'subtitle'}
            />
          </S.GuideWrapper>
        ))}
      </S.GuideContainer>
    </FormStatusInfo>
  ) : (
    <FormStatusInfo
      subTitle={[
        '감사합니다! 서류가 확인되어',
        '인터뷰 대상자로 등록되었습니다.',
      ]}
      image={<ImgDocChecked />}
      btn={
        <Btn
          height={44}
          fontStyle={'body2'}
          backGroundColor={'blue_opacity_100'}
          color={'blue_900'}
          onClick={onClick}
        >
          {'짐싸 파트너 사용법'}
        </Btn>
      }
      btnWidth={180}
      inHomeBtn={true}
    >
      <S.CaptionWrapper>
        짐싸 파트너는 고객과 업체 간의 공급/수요에 맞춰 지역별 파트너를 모집하고
        있습니다.
        <br />
        하단의 인터뷰 예상 대기 일을 참고해주시면, 해당 기간 내에 인터뷰
        연락드릴 수 있도록 하겠습니다.
        <br />
      </S.CaptionWrapper>
      <S.DateWrapper>
        <Label
          contents={'가입 신청일'}
          color={'gray_opacity_600'}
          fontStyle={'body2'}
        />
        <Label
          contents={createdDate}
          color={'gray_opacity_800'}
          fontStyle={'body1'}
        />
      </S.DateWrapper>
      <S.DateWrapper>
        <Label
          contents={'서류 승인일'}
          color={'gray_opacity_600'}
          fontStyle={'body2'}
        />
        <Label
          contents={checkedDate}
          color={'gray_opacity_800'}
          fontStyle={'body1'}
        />
      </S.DateWrapper>
      <SpaceDiv height={36} />
      <S.GuideTitleWrapper>
        <Label
          contents={'인터뷰 예상 대기일'}
          color={'gray_opacity_800'}
          fontStyle={'title_bold'}
        />
      </S.GuideTitleWrapper>
      <S.GuideContainer>
        {interviewExpectation?.map((item, index) => (
          <S.GuideWrapper key={index}>
            <Label
              contents={item.title}
              color={'gray_opacity_800'}
              fontStyle={'body2'}
            />
            <SpaceDiv height={4} />
            <Label
              contents={item.content}
              color={'gray_opacity_600'}
              fontStyle={'subtitle'}
            />
          </S.GuideWrapper>
        ))}
      </S.GuideContainer>
    </FormStatusInfo>
  );
}

export default DocChecked;
